export const loadActivationType = (orderCode) => {
  return (dispatch, getState, { api }) => {
    return api.getActivationType(orderCode).then(
      ({ result }) => {
        return {
          wasSuccessful: true,
          isActivationNeeded: result.activationNeeded,
        };
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
